import React from 'react';
import PropTypes from 'prop-types';
import useStringInterpolation from '../payment-calculator-hooks/string-interpolation-hook';
import { DisclosureText } from './disclosure.styles';
import useEstimatorStore from '../ui/estimator-store/estimator-store';

const Disclosure = ({ text }) => {
  const { params, extraParams } = useEstimatorStore();
  const stringInterpolate = useStringInterpolation();
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    if (Object.keys(params).length > 0 || Object.keys(extraParams).length > 0) {
      setIsLoaded(true);
    }
  }, [params, extraParams]);

  if (!isLoaded) {
    return null;
  }

  const formatNumbers = (data) => {
    return Object.keys(data).reduce((acc, key) => {
      if (data[key] == null) {
        acc[key] = '';
        return acc;
      }

      const cleanValue = typeof data[key] === 'string'
        ? data[key].replace(/,/g, '')
        : data[key];

      const numValue = parseFloat(cleanValue);

      if (!isNaN(numValue)) {
         if (key.toLowerCase().includes('apr')) {
           acc[key] = numValue.toFixed(2);
         } else if (key.toLowerCase() === 'amount') {
           acc[key] = numValue.toLocaleString(undefined, {
             minimumFractionDigits: numValue % 1 !== 0 ? 2 : 0,
             maximumFractionDigits: 2,
           });
         } else {
           acc[key] = numValue.toLocaleString();
         }
       } else {
         acc[key] = String(data[key]);
       }

      return acc;
    }, {});
  };

  const data = { ...params, ...extraParams };
  const formattedData = formatNumbers(data);
  const cleanText = text ? text.replace(/['"]+/g, '').trim() : '';

  const interpolatedText = stringInterpolate(cleanText || '', formattedData, {
    sanity: false,
  });

  if (!text) {
    console.warn('Disclosure component requires a text prop');
    return null;
  }

  return <DisclosureText>{interpolatedText}</DisclosureText>;
};

Disclosure.propTypes = {
  text: PropTypes.string.isRequired
};

export default Disclosure;
